import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { threadProjectsBackend } from './thread-projects.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { threadProjectsReducer } from './thread-projects.reducer';

// FIXME: remove that
backend.threadProjects = threadProjectsBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('threadProjects', threadProjectsReducer),
    /* DatastoreBackendModule.forFeature(
      'threadProjects',
      threadProjectsBackend,
    ),*/
  ],
})
export class DatastoreThreadProjectsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/thread-projects/thread-projects.module.ts